import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { get, isArray } from 'lodash';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { DisplayEuro } from 'src/utils/formats';
import theme from '../../../assets/theme/theme';
import LoadingBackdrop from '../../../components/ui-component/loading/LoadingBackdrop';
import MUIToolTip from '../../../components/ui-component/mui-tooltip/MUIToolTip';
import NoDetailsInfo from '../../../components/ui-component/no-details-info/NoDetailsInfo';
import { getLocalstorageToken } from '../../../context/AuthHelper';
import GetRecord from '../../../lib/api/GetRecord';
import POP_LEVEL from '../../../lib/api/Populations.json';
import { PostRecord } from '../../../lib/api/PostRecord';
import { APIS } from '../../../lib/constants/apis';
import { ANTRAG_TYP, ANTRAGS_FORMULAREN, ANTRAGS_STATUS, KOSTEN_ARTEN, MONAT_LISTE } from '../../../lib/constants/constant';
import { PAGES_URLS } from '../../../lib/constants/routes';
import { enumT, removeDataKeys, removeNullDeep } from '../../../utils/helper';
import EbusseFoerderDashboard from './ebusse/EbusseFoerderDashboard';
import EmobFundEFoerderDashborad from './emob/EmobFundEFoerderDashborad';
import EmobInvestFoerderDashboard from './emob/EmobInvestFoerderDashboard';
import EpzFoerderDashboard from './epz/EpzFoerderDashboard';
import KreativwirtschaftDashboard from './kreativwirtschaft/KreativwirtschaftDashboard';
import LoeweFoerderDashboard from './loewe/LoeweFoerderDashboard';
import LogMobFoerderDashboard from './logmob/LogMobFoerderDashboard';
import MessefoerderDashboard from './messefoerderung/MessefoerderDashboard';
import MobilitaetsplaeneDashboard from './mobilitaetsplaene/MobilitaetsplaeneDashboard';
import StartUpProjekteDashboard from './startupprojekte/StartUpProjekteDashboard';
import StartupStipendiumFoerderDashboard from './startupstipendium/StartupStipendiumFoerderDashboard';

// import Schema
import AenderungAnfrageSchema from 'src/lib/paths/aenderungsanfrage_FULL_Paths.json';
import AntragSchema from 'src/lib/paths/antrag_FOERDERUNG_UEBERSICHT_SEITE_Paths.json';
import FoerderProgrammSchema from 'src/lib/paths/foerderprogramm_FULL_Paths.json';
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const KP_P = KostenPositionSchema.attributes;
const FP_P = FoerderProgrammSchema.attributes;
const P = AntragSchema.attributes;
const AF_P = AenderungAnfrageSchema.attributes;

const FoerderungUebersicht = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const numericId = get(location, 'state.id');

	const [applicationData, setApplicationData] = useState({});
	const [foerderProgrammDetails, setFoerderProgrammDetails] = useState({});
	const [loading, setLoading] = useState<boolean>(false);

	const getFoerderungUebersichtBeschreibung = () => {
		return get(foerderProgrammDetails, FP_P.Texte_Meine_Foerderung_Dashboard_Inhalt.path, '');
	};

	const handleCreateAenderungsAnfrage = async () => {
		const antrag_OBJ =
			get(applicationData, P.Allgemein_Typ.path, '') === ANTRAG_TYP.Skizze ? get(applicationData, P.Skizze_Antrags.path, {}) : applicationData;
		const anfrageData = {
			Antragsteller: get(getLocalstorageToken(), 'organisationId'),
			Antrag: get(antrag_OBJ, 'id'),
			Foerderprogramm: get(applicationData, `${P.Foerderprogramm.path}.id`),
			Status_Status: ANTRAGS_STATUS.inBearbeitung,
			Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation: get(
				applicationData,
				P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path,
			),
		};

		try {
			setLoading(true);
			let res = await PostRecord(APIS.AenderungsAnfrage, { data: anfrageData });
			if (res)
				navigate(PAGES_URLS.OnlineAntrag, {
					state: {
						id: get(res, 'data.id'),
						api: APIS.AenderungsAnfrage,
					},
				});
		} catch (err: any) {
			console.error('ERROR: Creating Änderungsanrage ', err);
		} finally {
			setLoading(false);
		}
	};

	const RenderAenderungsAnfrageButton: FC<{}> = () => {
		const antrag_OBJ =
			get(applicationData, P.Allgemein_Typ.path, '') === ANTRAG_TYP.Skizze ? get(applicationData, P.Skizze_Antrags.path, {}) : applicationData;

		const AenderungsAnfragen = get(antrag_OBJ, P.Antrag_Aenderungsanfrages.path, []);
		const lastAenderungsAnfragenStatus = get(AenderungsAnfragen[AenderungsAnfragen.length - 1], AF_P.Status_Status.path, '');

		let isAenderungsAnfrageErstellenButtonDisabled: boolean =
			lastAenderungsAnfragenStatus === ANTRAGS_STATUS.antragFreigeben || lastAenderungsAnfragenStatus === ANTRAGS_STATUS.abgelehnt ? false : true;

		if (isArray(AenderungsAnfragen) && AenderungsAnfragen.length > 0) {
			return (
				<AntragsButtonWrapper title='Änderungsanfrage:'>
					{AenderungsAnfragen.map((eachAEFrage: any, i: number) => {
						return (
							<AntragButton
								key={i}
								name={`Änderungsanfrage #${i + 1}`}
								description={enumT(get(eachAEFrage, 'attributes.Status_Status', ''))}
								onClick={() =>
									navigate(PAGES_URLS.OnlineAntrag, {
										state: {
											id: get(eachAEFrage, 'id'),
											api: APIS.AenderungsAnfrage,
										},
									})
								}
							/>
						);
					})}

					<MUIToolTip
						title='Sie können neue Änderungsanfrage erstellen, sobald die vorherige Änderungsanfrage entweder freigegeben oder abgelehnt ist'
						showTootip={isAenderungsAnfrageErstellenButtonDisabled}
					>
						<AntragButton
							name='Änderunganfrage'
							description='Änderungsanfrage erstellen'
							onClick={handleCreateAenderungsAnfrage}
							variant='contained'
							disabled={isAenderungsAnfrageErstellenButtonDisabled}
						/>
					</MUIToolTip>
				</AntragsButtonWrapper>
			);
		} else {
			if (get(antrag_OBJ, P.Antragstatus_Antragstatus.path, '') === ANTRAGS_STATUS.inFoerderung) {
				return (
					<AntragsButtonWrapper title='Änderungsanfrage:'>
						<AntragButton
							name='Änderunganfrage'
							description='Änderungsanfrage erstellen'
							onClick={handleCreateAenderungsAnfrage}
							variant='contained'
						/>
					</AntragsButtonWrapper>
				);
			}
		}
		return <></>;
	};
	const RenderDashboard = () => {
		const antragsFormular = get(applicationData, P.Allgemein_Antragsformular.path);

		switch (antragsFormular) {
			// Elektromobilität
			case ANTRAGS_FORMULAREN.EmobFundE:
				return <EmobFundEFoerderDashborad application={applicationData} foerderProgramm={foerderProgrammDetails} />;
			case ANTRAGS_FORMULAREN.EmobInvest:
			case ANTRAGS_FORMULAREN.EmobLis:
				return <EmobInvestFoerderDashboard application={applicationData} />;
			// Messeförderung
			case ANTRAGS_FORMULAREN.Messefoerderung:
				return <MessefoerderDashboard application={applicationData} />;
			// StartUp Projekte
			case ANTRAGS_FORMULAREN.StartUpProjekte:
				return <StartUpProjekteDashboard application={applicationData} />;
			// Kreativwirtschaft
			case ANTRAGS_FORMULAREN.Kreativwirtschaft:
				return <KreativwirtschaftDashboard application={applicationData} />;
			// Mobilitätspläne
			case ANTRAGS_FORMULAREN.Mobilitaetsplaene:
				return <MobilitaetsplaeneDashboard application={applicationData} />;
			// Entwicklungszusammenarbeit
			case ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit:
				return <EpzFoerderDashboard application={applicationData} />;
			// LÖWE-Förderlinie
			case ANTRAGS_FORMULAREN.Loewe:
				return <LoeweFoerderDashboard application={applicationData} foerderProgramm={foerderProgrammDetails} />;
			// Elektrobusse
			case ANTRAGS_FORMULAREN.Elektrobusse:
				return <EbusseFoerderDashboard application={applicationData} />;
			// Logistik und Mobilität
			case ANTRAGS_FORMULAREN.LogistikUndMobilitaet:
				return <LogMobFoerderDashboard application={applicationData} foerderProgramm={foerderProgrammDetails} />;
			// Startup Stipendium
			case ANTRAGS_FORMULAREN.StartUpStipendium:
				return <StartupStipendiumFoerderDashboard application={applicationData} foerderProgramm={foerderProgrammDetails} />;
			default:
				return <></>;
		}
	};

	// Fetch application
	useEffect(() => {
		const fetch = async () => {
			setLoading(true);
			try {
				// let res = await GetRecord(APIS.Antrag, numericId, POP_LEVEL.antrag.FOERDERUNG_UEBERSICHT_SEITE);
				let res = await GetRecord(APIS.Antrag, numericId, { customPopulate: 'Foerderdashboard' });
				const app = removeNullDeep(removeDataKeys(get(res, 'data', {})));

				let programmRes = await GetRecord(
					APIS.FörderProgramme,
					get(app, `${P.Foerderprogramm.path}.id`),
					POP_LEVEL.foerderprogramm.DETAILS_SEITE,
				);
				setApplicationData(app);
				setFoerderProgrammDetails(removeNullDeep(removeDataKeys(get(programmRes, 'data', {}))));
			} catch (err: any) {
				console.error('ERROR: Fetching Application ', err);
			} finally {
				setLoading(false);
			}
		};
		if (numericId) fetch();
	}, [numericId]);

	if (!numericId) return <NoDetailsInfo title='Antrag' goBackUrl={PAGES_URLS.MeineFoerderung} />;
	if (loading) return <LoadingBackdrop open={loading} />;
	const isSkizzeTyp = get(applicationData, P.Allgemein_Typ.path, '') === ANTRAG_TYP.Skizze;
	const hasSkizzeAntrag = Boolean(get(applicationData, `${P.Skizze_Antrags.path}.id`));
	const displayDataForAntragInfo = isSkizzeTyp && hasSkizzeAntrag ? get(applicationData, P.Skizze_Antrags.path, {}) : applicationData;

	const RenderProjektNummerInfo = () => {
		const projektNummer = get(displayDataForAntragInfo, P.Allgemein_HA_Projekt_Nr.path, '');
		const eingangsnummer = get(displayDataForAntragInfo, P.Allgemein_Eingangsnummer.path, '-');
		const hasProjektNummer = Boolean(projektNummer);
		const label = hasProjektNummer ? 'Projektnummer:' : 'Eingangsnummer:';
		const value = hasProjektNummer ? projektNummer : eingangsnummer || '-';

		return (
			<Box>
				<Typography>{label}</Typography>
				<Typography variant='h6' component={'p'}>
					{enumT(value)}
				</Typography>
			</Box>
		);
	};

	return (
		<>
			<Container>
				<Stack spacing={3} className='buit-dashboard'>
					<span>
						<Typography variant='h3' component='h2'>
							Mein Vorhaben: {get(applicationData, P.Allgemein_Projekttitel.path, '')}
						</Typography>
						<Typography variant='body1'> Förderprogramm: {enumT(get(applicationData, P.Allgemein_Antragsformular.path))}</Typography>
					</span>
					<Stack
						direction='row'
						sx={{ backgroundColor: 'background.paper', display: { xs: 'none', md: 'inherit' }, padding: '1rem' }}
						spacing={6}
						justifyContent={'space-between'}
					>
						<Box>
							<Typography>Status:</Typography>
							<Typography variant='h6' component={'p'}>
								{enumT(get(displayDataForAntragInfo, P.Antragstatus_Antragstatus.path, ''))}
							</Typography>
						</Box>
						<Box>
							<Typography>Förderprogramm:</Typography>
							<Typography variant='h6' component={'p'}>
								{enumT(get(applicationData, P.Allgemein_Antragsformular.path, ''))}
							</Typography>
						</Box>
						<RenderProjektNummerInfo />
						<Box>
							<Typography>Förderung:</Typography>
							<Typography variant='h6' component={'p'}>
								{DisplayEuro(get(displayDataForAntragInfo, P.Allgemein_Beantragte_Zuwendung.path, 0))}
							</Typography>
						</Box>
					</Stack>
					<MarkdownRenderer markdown={getFoerderungUebersichtBeschreibung()} />
					<Box sx={{ maxWidth: 'fit-content' }}>
						<RenderAenderungsAnfrageButton />
					</Box>
					{/* ** Render Dashboard abhängig von Antragsformular ** */}
					<RenderDashboard />
				</Stack>
			</Container>
		</>
	);
};

export default FoerderungUebersicht;

type AntragButtonProps = {
	name: string;
	description: string;
	onClick: () => void;
	variant?: 'text' | 'outlined' | 'contained';
	disabled?: boolean;
};
export const AntragButton: FC<AntragButtonProps> = ({ name, description, onClick, disabled, variant = 'outlined' }) => {
	return (
		<>
			<Button
				disabled={disabled}
				variant={'outlined'}
				onClick={() => onClick()}
				sx={{
					borderRadius: 0,
					borderColor: theme.palette.border.primary,
					backgroundColor: disabled ? theme.palette.action.disabled : '#fff',
					color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
					textAlign: 'left',
					width: '26.5rem',
					justifyContent: 'space-between',
					padding: '1rem 1rem',
					marginTop: '0.5rem !important',
					maxWidth: 'unset',
				}}
				endIcon={variant === 'contained' ? <AddIcon sx={{ fontSize: '1.5rem !important' }} /> : null}
			>
				<Stack>
					<Typography variant='h5' sx={{ fontWeight: 400 }}>
						{name}
					</Typography>
					<Typography variant='body2'>{description}</Typography>
				</Stack>
			</Button>
		</>
	);
};

type AntragsButtonWrapperType = {
	title: string;
	children: ReactNode;
};
export const AntragsButtonWrapper: FC<AntragsButtonWrapperType> = ({ title, children }) => {
	return (
		<Stack spacing={0} sx={{ mt: '1rem' }}>
			<Typography variant='h6'>{title}</Typography>
			<Stack direction={'column'} columnGap={5}>
				{children}
			</Stack>
		</Stack>
	);
};

export const getMonatListe = (kostenPositionData: any) => {
	if (get(kostenPositionData, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten) {
		return MONAT_LISTE;
	} else {
		return [];
	}
};
